// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthHandoffRouteImport } from './routes/auth/handoff'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthRelayLoginRouteImport } from './routes/auth/relay-login'
import { Route as AuthenticatedProjectsIndexRouteImport } from './routes/_authenticated/projects/index'
import { Route as AuthenticatedProjectsProjectIdRouteImport } from './routes/_authenticated/projects/$projectId'
import { Route as AuthenticatedProjectsNewRouteImport } from './routes/_authenticated/projects/new'
import { Route as AuthenticatedProjectsProjectIdIndexRouteImport } from './routes/_authenticated/projects/$projectId/index'
import { Route as AuthenticatedProjectsProjectIdSourcesIndexRouteImport } from './routes/_authenticated/projects/$projectId/sources/index'
import { Route as AuthenticatedProjectsProjectIdSourcesNewRouteImport } from './routes/_authenticated/projects/$projectId/sources/new'
import { Route as AuthenticatedProjectsProjectIdSourcesSourceIdIndexRouteImport } from './routes/_authenticated/projects/$projectId/sources/$sourceId/index'
import { Route as AuthenticatedProjectsProjectIdSourcesSourceIdWorkbenchRouteImport } from './routes/_authenticated/projects/$projectId/sources/$sourceId/workbench'
import { Route as AuthenticatedProjectsProjectIdSourcesSourceIdRepresentationsRepresentationIdRouteImport } from './routes/_authenticated/projects/$projectId/sources/$sourceId/representations/$representationId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRoute
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const AuthHandoffRoute = AuthHandoffRouteImport.update({
            id: '/auth/handoff',path: '/auth/handoff',getParentRoute: () => rootRouteImport
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/auth/login',path: '/auth/login',getParentRoute: () => rootRouteImport
          })
const AuthRegisterRoute = AuthRegisterRouteImport.update({
            id: '/auth/register',path: '/auth/register',getParentRoute: () => rootRouteImport
          })
const AuthRelayLoginRoute = AuthRelayLoginRouteImport.update({
            id: '/auth/relay-login',path: '/auth/relay-login',getParentRoute: () => rootRouteImport
          })
const AuthenticatedProjectsIndexRoute = AuthenticatedProjectsIndexRouteImport.update({
            id: '/projects/',path: '/projects/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedProjectsProjectIdRoute = AuthenticatedProjectsProjectIdRouteImport.update({
            id: '/projects/$projectId',path: '/projects/$projectId',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedProjectsNewRoute = AuthenticatedProjectsNewRouteImport.update({
            id: '/projects/new',path: '/projects/new',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedProjectsProjectIdIndexRoute = AuthenticatedProjectsProjectIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedProjectsProjectIdRoute
          })
const AuthenticatedProjectsProjectIdSourcesIndexRoute = AuthenticatedProjectsProjectIdSourcesIndexRouteImport.update({
            id: '/sources/',path: '/sources/',getParentRoute: () => AuthenticatedProjectsProjectIdRoute
          })
const AuthenticatedProjectsProjectIdSourcesNewRoute = AuthenticatedProjectsProjectIdSourcesNewRouteImport.update({
            id: '/sources/new',path: '/sources/new',getParentRoute: () => AuthenticatedProjectsProjectIdRoute
          })
const AuthenticatedProjectsProjectIdSourcesSourceIdIndexRoute = AuthenticatedProjectsProjectIdSourcesSourceIdIndexRouteImport.update({
            id: '/sources/$sourceId/',path: '/sources/$sourceId/',getParentRoute: () => AuthenticatedProjectsProjectIdRoute
          })
const AuthenticatedProjectsProjectIdSourcesSourceIdWorkbenchRoute = AuthenticatedProjectsProjectIdSourcesSourceIdWorkbenchRouteImport.update({
            id: '/sources/$sourceId/workbench',path: '/sources/$sourceId/workbench',getParentRoute: () => AuthenticatedProjectsProjectIdRoute
          })
const AuthenticatedProjectsProjectIdSourcesSourceIdRepresentationsRepresentationIdRoute = AuthenticatedProjectsProjectIdSourcesSourceIdRepresentationsRepresentationIdRouteImport.update({
            id: '/sources/$sourceId/representations/$representationId',path: '/sources/$sourceId/representations/$representationId',getParentRoute: () => AuthenticatedProjectsProjectIdRoute
          })





const AuthenticatedProjectsProjectIdRouteChildren = {
  AuthenticatedProjectsProjectIdIndexRoute: AuthenticatedProjectsProjectIdIndexRoute,AuthenticatedProjectsProjectIdSourcesNewRoute: AuthenticatedProjectsProjectIdSourcesNewRoute,AuthenticatedProjectsProjectIdSourcesIndexRoute: AuthenticatedProjectsProjectIdSourcesIndexRoute,AuthenticatedProjectsProjectIdSourcesSourceIdWorkbenchRoute: AuthenticatedProjectsProjectIdSourcesSourceIdWorkbenchRoute,AuthenticatedProjectsProjectIdSourcesSourceIdIndexRoute: AuthenticatedProjectsProjectIdSourcesSourceIdIndexRoute,AuthenticatedProjectsProjectIdSourcesSourceIdRepresentationsRepresentationIdRoute: AuthenticatedProjectsProjectIdSourcesSourceIdRepresentationsRepresentationIdRoute
}

const AuthenticatedProjectsProjectIdRouteWithChildren = AuthenticatedProjectsProjectIdRoute._addFileChildren(AuthenticatedProjectsProjectIdRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedProjectsProjectIdRoute: AuthenticatedProjectsProjectIdRouteWithChildren,AuthenticatedProjectsNewRoute: AuthenticatedProjectsNewRoute,AuthenticatedProjectsIndexRoute: AuthenticatedProjectsIndexRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AuthCallbackRoute: AuthCallbackRoute,AuthHandoffRoute: AuthHandoffRoute,AuthLoginRoute: AuthLoginRoute,AuthRegisterRoute: AuthRegisterRoute,AuthRelayLoginRoute: AuthRelayLoginRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)